import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $f7 = _ref.$f7;
  var page_name = 'nvut-baocao-popup'; // console.log(props.emp);
  // console.log(props.ngay);

  var total_so_tien = 0,
      rows = [],
      rs;
  var x = props.ngay.split('-');
  var ngay_reverse = "".concat(x[1], "/").concat(x[0]);

  var chitiet = function chitiet(e) {
    var id = parseInt($(e.target).data('id'));
    var rows_chitiet = rs.rows.filter(function (r) {
      return r.id_tieuchi === id;
    });
    var content = rows_chitiet.map(function (row) {
      return "<div>".concat(moment(row.created_at).format('D/M HH:mm'), "</div>");
    }).join('');
    $f7.dialog.create({
      title: "Vi ph\u1EA1m ".concat(rows_chitiet.length, " l\u1EA7n"),
      content: content,
      closeByBackdropClick: true
    }).open();
  };

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var times, _loop, id_tieuchi;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Base.call({
              method: '_get',
              table: 'nvut_baocao',
              params: {
                fields: 'nvut_baocao.*, nvut_tieuchi.name',
                join: 'JOIN nvut_tieuchi ON nvut_tieuchi.id = nvut_baocao.id_tieuchi',
                where: 'id_emp=:id_emp AND ngay LIKE :ngay',
                where_data: {
                  id_emp: props.emp.id,
                  ngay: "".concat(props.ngay, "%")
                }
              }
            });

          case 2:
            rs = _context.sent;

            if (!(rs.rows.length === 0)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            times = {};
            rs.rows.forEach(function (row) {
              if (times[row.id_tieuchi] === undefined) {
                times[row.id_tieuchi] = 1;
              } else {
                times[row.id_tieuchi] += 1;
              }

              total_so_tien += parseInt(row.so_tien);
            });

            _loop = function _loop(id_tieuchi) {
              var row = rs.rows.find(function (r) {
                return r.id_tieuchi === parseInt(id_tieuchi);
              });
              rows.push({
                name: row.name,
                so_tien: row.so_tien,
                times: times[id_tieuchi],
                id_tieuchi: parseInt(id_tieuchi)
              });
            };

            for (id_tieuchi in times) {
              _loop(id_tieuchi);
            }

            rows.sort(function (a, b) {
              if (a.times > b.times) return -1;
              if (a.times < b.times) return 1;
              return 0;
            });
            $update();

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup ${page_name}" data-name="${page_name}">
    <div class="view">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">${props.emp.name} tháng ${ngay_reverse}</div>
          <div class="right">
            <a href="#" class="link popup-close" data-popup=".${page_name}"><i class="icon f7-icons">multiply</i></a>
          </div>
        </div>
      </div>
      <div class="page">
        <div class="page-content">
          <div class="block text-align-center">
            <h3 class="text-color-orange">Tổng: -${Utils.num2Str(total_so_tien)}</h3>
          </div>
    
          <div class="block-title">Bảng kê chi tiết</div>

          <div class="card data-table">
            <table>
              <thead>
                <tr>
                  <th>Lỗi</th>
                  <th class="numeric-cell">Số tiền</th>
                  <th class="numeric-cell">Số lần</th>
                  <th class="numeric-cell">Thành tiền</th>
                </tr>
              </thead>
              <tbody>
                ${rows.length > 0 && rows.map(row=>$h`
                  <tr>
                    <td><a @click="${chitiet}" data-id="${row.id_tieuchi}">${row.name}</a></td>
                    <td class="numeric-cell">${Utils.num2Str(row.so_tien)}</td>
                    <td class="numeric-cell">x${row.times}</td>
                    <td class="numeric-cell">${Utils.num2Str( Utils.str2Num(row.times) * Utils.str2Num(row.so_tien))}</td>
                  </tr>
                `)}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});